module.exports = __webpack_public_path__ + "static/media/01-05.bce21ffb.mp3";